export const isSelectedTrueDropdown = (value: string): boolean => value === 'true';
